import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import MainLayout from "../../layouts/MainLayout";

const VideoBookList = () => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();

  const [myBooks, setMyBooks] = useState([]);
  const [selectedBookId, setSelectedBookId] = useState(null);
  const [fetchData] = useFetch();

  const fetchMyBooks = useCallback(() => {
    const config = {
      url: "/mybooks/forvideobooks",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id },
    };

    fetchData(config)
      .then((response) => {
        if (response && Array.isArray(response.mybooks)) {
          setMyBooks(response.mybooks);
        } else {
          console.error("Invalid response format: Book not found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching MyBooks:", error);
      });
  }, [authState.token, authState.user._id, fetchData]);

  useEffect(() => {
    if (authState.isLoggedIn) fetchMyBooks();
  }, [authState.isLoggedIn, fetchMyBooks]);

  const handleVideoBookClick = (bookId) => {
    navigate("/videobook", {state : {bookId: bookId}})
  };

 const sortedBooks = myBooks.sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate));

  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4">
      {sortedBooks.length === 0 && (
        <p className="text-yellow-500 text-center text-xl sm:text-2xl lg:text-3xl mt-6 font-bold">
          You do not have any Video Book!!
        </p>
      )}
    
      <div className="grid gap-6 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4">
        {sortedBooks.map((book, index) => (
          <div
            key={book.bookCode}
            className="flex flex-col justify-between bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition-transform duration-300 ease-in-out"
          >
            <div className="p-6">
              <h2 className="text-orange-600 text-sm sm:text-m lg:text-lg font-semibold mb-2">
                #{index + 1}: {book.bookTitle}
              </h2>
    
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white text-sm sm:text-base font-semibold py-2 px-4 transition duration-300 ease-in-out w-full mt-4"
                onClick={() => handleVideoBookClick(book.bookId)}
                disabled={book.isCollection}
              >
                Watch Videos
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>  
  );
};

export default VideoBookList;
